import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'app/shared/constant/api-service/api.service';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';
import { Search } from 'js-search';

@Injectable({
    providedIn: 'root',
})
export class FaqService {
    private searchEngine: Search;
    constructor(private _apiService: ApiService) {
        this.searchEngine = new Search('id');
    }

    getFaqs(): Observable<any> {
        return this._apiService.get(API_ENDPOINTS.FAQ);
    }

    initializeSearch(jsonData: any[], searchableFields: string[]): void {
        jsonData?.forEach((item) => {
            if (item?.faq?.length > 0) {
                item?.faq?.forEach((faqItem: any) => {
                    const temp = {
                        ...faqItem,
                        subCat: false,
                        categoryEn: item?.categoryEn,
                        categoryBm: item?.categoryBm,
                    };
                    this.searchEngine.addDocuments([temp]);
                });
            } else {
                item?.subcategories?.forEach((subCat) => {
                    subCat?.faq?.forEach((faqItem: any) => {
                        const temp = {
                            ...faqItem,
                            subCat: true,
                            subCatEn: subCat?.categoryEn,
                            subCatBm: subCat?.categoryBm,
                            categoryEn: item?.categoryEn,
                            categoryBm: item?.categoryBm,
                        };
                        this.searchEngine.addDocuments([temp]);
                    });
                });
            }
        });
        searchableFields.forEach((field) => this.searchEngine.addIndex(field));
    }

    search(query: string): any[] {
        return this.searchEngine.search(query);
    }
}
